import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { history } from '@store/history';
import styles from './styles.scss';
import PageContainer from 'containers/en/page-container';
import Axios from 'axios';
import { useTranslation } from 'hooks/use-translation';

const cx = classNames.bind(styles);

const imgList1 = [
	'https://web-data.zmlearn.com/image/nKjLA5gyJ4SvQYsWpTPqBL/about_1%402x.png',
	'https://web-data.zmlearn.com/image/77TGQonsDs9JvDv521LUiS/about_2%402x.png',
	'https://web-data.zmlearn.com/image/b4fv5pgXtUjUTYDSvW1gzw/about_3%402x.png',
	'https://web-data.zmlearn.com/image/dvqrpzYGeo1SCUq8qGJjBR/about_4%402x.png',
];
const imgList2 = [
	'https://web-data.zmlearn.com/image/9vCL4KyYPmYecz9S7RXdqV/about_5%402x.png',
	'https://web-data.zmlearn.com/image/ko1WiyGCW4B6h1mkpiNcwG/about_6%402x.png',
	'https://web-data.zmlearn.com/image/gc8T6NsC9DYdbTuKhw9TgA/about_7%402x.png',
];

function JoinUs(props: Record<string, any>) {
	const [works, setWorks] = useState<any[]>([]);
	const { transData } = useTranslation('joinUs');
	const { title, safeItems, bottomTitle } = transData;
	useEffect(() => {
		Axios.get(`https://web-data.zmlearn.com/config/5JX8dsopNXEWrLLeqLHrMC/data.json?time=${new Date().getTime()}`, { timeout: 4000 }).then(
			(res) => {
				setWorks(res.data.slice(0, 4));
			}
		);
	}, []);
	const toDetail = (id: number) => {
		history.push(`/en/recruit/detail/${id}`);
	};

	return (
		<PageContainer>
			<div className={cx('for-parents')}>
				<div className={cx('banner-wrap')}>
					<div className={cx('banner')} />
					<div className={cx('banner-desc-wrap')}>
						<div className={cx('banner-title')}>{title}</div>
					</div>
				</div>

				<div className={cx('safe-wrap')}>
					<div className={cx('safe-item', 'safe-item-1')}>
						<div className={cx('icon')}></div>
						<div className={cx('name')}>{safeItems[0]}</div>
					</div>
					<div className={cx('safe-item', 'safe-item-2')}>
						<div className={cx('icon')}></div>
						<div className={cx('name')}>{safeItems[1]}</div>
					</div>
					<div className={cx('safe-item', 'safe-item-3')}>
						<div className={cx('icon')}></div>
						<div className={cx('name')}>{safeItems[2]}</div>
					</div>
				</div>
				<div className={cx('space')}>
					<div className={cx('img-wrap')}>
						<div className={cx('img-list', 'upper', 'scroll-view')}>
							{imgList1.map((item, index) => (
								<img loading="lazy" key={index} src={item} alt="" />
							))}
						</div>
						<div className={cx('img-list', 'lower', 'scroll-view')}>
							{imgList2.map((item, index) => (
								<img loading="lazy" key={index} src={item} alt="" />
							))}
						</div>
					</div>
				</div>
				<div className={cx('work')}>
					<div className={cx('work-title')}>{bottomTitle}</div>
					<div className={cx('en-recruit-items')}>
						{works.map((item, index) => (
							<div key={index} className={cx('item-cur')}>
								<div className={cx('item-content')}>
									<div className={cx('item-title')} onClick={() => toDetail(item.id)}>
										{item.job}
									</div>
									<div className={cx('item-desc')}>
										{item.workType} | {item.department} | {item.country}{' '}
									</div>
								</div>
								<div className={cx('controls')} onClick={() => toDetail(item.id)}>
									Apply Now ➞
								</div>
							</div>
						))}
						<div className={cx('btn-wrap')} onClick={() => history.push('/en/recruit')}>
							<div className={cx('all-jobs')}>All Jobs</div>
						</div>
					</div>
				</div>
			</div>
		</PageContainer>
	);
}

export default JoinUs;
